const state = {
    Items: {
        data: [],
        total: 0,
        pages: {
            page: 1,
            totalPage: 1,
            limit: 100,
            filter: {

            }
        },
    },
    Loadings: {
        list: false,
        detail: false,
        detailChecklist: false,
    },
    Item: null,
    Checklist: null
};

const getters = {

};

const actions = {
    async liftInspectionReport({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/lift-inspection-report`, {
                    method: "POST",
                    data: params,
                    responseType: 'blob',
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    const reader = new FileReader();
                    reader.onload = function() {
                        error.response.data = JSON.parse(this.result);
                        reject(error);
                    };

                    reader.onerror = () => {
                        reject(error);
                    };

                    reader.readAsText(error.response.data);
                })
        });
    },
    async getSettingsForLiftInspectionReport({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/lift-inspection-report`, {
                    method: "GET",
                    params: params
                })
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => {
                    reject(error);
                })
        });
    },
    async storeSettingsForLiftInspectionReport({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/lift-inspection-report`, {
                    method: "PUT",
                    data: params
                })
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => {
                    reject(error);
                })
        });
    },

    /* Companies */
    async getLiftReportCompanies({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/lift-inspection-report/companies`, {
                    method: "GET",
                    params: params
                })
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => {
                    reject(error);
                })
        });
    },
    /* Antentions */
    async getLiftReportAntentions({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/lift-inspection-report/attentions`, {
                    method: "GET",
                    params: params
                })
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => {
                    reject(error);
                })
        });
    },
};

const mutations = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}